import { Button } from 'components/Button';
import styles from './filterButton.scss';
import cn from 'classnames';
import { getQaDataAttr } from '@bygghemmait/utilities';

type FilterButtonAppearance = 'filter' | 'filterOpen';

interface FilterButtonProps {
  title: string;
  onClick: () => void;
  className?: string;
  isSortButton?: boolean;
  shouldClose: boolean;
  isFilterActive?: boolean;
  isDropdown: boolean;
  children: React.ReactNode;
}

export const FilterButton = ({
  title,
  onClick,
  className,
  isSortButton,
  shouldClose,
  isDropdown,
  isFilterActive,
  children
}: FilterButtonProps) => {
  const appearance: FilterButtonAppearance = shouldClose ? 'filterOpen' : 'filter';
  const preventDefault = (e: React.MouseEvent) => e.preventDefault();

  return (
    <Button
      onMouseDown={preventDefault}
      onClick={onClick}
      className={cn(styles.customButton, className, {
        [styles.filter]: appearance === 'filter',
        [styles.filterOpen]: appearance === 'filterOpen',
        [styles.activeButtonBorder]: isFilterActive,
        [styles.inactiveButtonBorder]: !isFilterActive,
        [styles.sortButton]: isSortButton,
        [styles.buttonOpen]: shouldClose,
        [styles.notDropdown]: !isDropdown
      })}
      size="medium"
      title={title}
      {...getQaDataAttr(`${isSortButton ? 'sort-filter' : `filter`}`)}
    >
      {children}
    </Button>
  );
};
